require('../../fhApp/transformResource');

angular.module('app.myHockeyTv.manageReminders.remindersListService', [
  'app.transformResource'
])
  .factory('app.myHockeyTv.manageReminders.remindersListService', [
    '$http', 'app.transformResource',
    function ($http, transformResource) {
      "use strict";

      let reminders = {
        list: null,
        error: null,
        retrieve: function () {
          return $http({
            method: 'GET',
            url: window.location.api('reminders'),
            transformResponse: transformResource.onResponse(function (data) {
              if (data.results) {

              }
              return data;
            })
          }).then(
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              let data = response.data;

              if (data.results) {
                reminders.list = data.results;

                _.forEach(reminders.list, (reminder) => {
                  reminder.calendar.calstartdate = moment(reminder.calendar.calstartdate).toDate();
                  reminder.calendar.calenddate = moment(reminder.calendar.calenddate).toDate();
                })
              }
              if (data.error) {
                return reminders.error = data.error;
              }
            },
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              let data = response.data;
              let message;
              if (data.error) {
                message = data.error;
              } else {
                message = 'Failed to retrieve reminders';
              }
              return reminders.error = message;
            }
          );
        }
      };
      return reminders;
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/manageReminders/remindersListService.js